export default {
  deliveryOrders: [],
  deliveryOrder: undefined,
};
